import { translateColumns } from "../../../../../../../../utils/tableUtils";
import { useTranslation } from "react-i18next";
import React from 'react'

const DetailConfirm = () => {
return (
    <div>DetailConfirm</div>
  )
}

export default DetailConfirm